import { AxiosCallPostWithErr2 } from './apicall'
import { LynxUtils } from '@/utils'

/**
 * Service top operate on documents
 */
export default class DocumentService {
  /**
 * Constructor.
 * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
 */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  async findDocumentsForContact (contactid) {
    const res = await AxiosCallPostWithErr2('lynxapi/document/finddocumentsforcontact', {contactid: contactid})
    if (res == null) {
      return []
    }
    return res.result.sort((a, b) => LynxUtils.ParseDate(b.date) - LynxUtils.ParseDate(a.date))
  }

  async findDocumentsForOpp (oppid) {
    const res = await AxiosCallPostWithErr2('lynxapi/document/finddocumentsforopp', {id: oppid})
    if (res == null) {
      return []
    }
    return res.result.sort((a, b) => LynxUtils.ParseDate(b.date) - LynxUtils.ParseDate(a.date))
  }

  async downloadDocument (docId) {
    const res = await AxiosCallPostWithErr2('lynxapi/document/dowloaddocument', {docId: docId})
    if (res?.result == null) {
      return []
    }

    const url = window.URL.createObjectURL(this.base64ToBlob(res.result.contentB64, res.result.contentType))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', res.result.name)
    document.body.appendChild(link)
    link.click()
    // Optionnel : Ouvrir le fichier dans un nouvel onglet si c'est un PDF ou une image
    window.open(url, '_blank')
    window.URL.revokeObjectURL(url)
  }

  base64ToBlob (base64, type) {
    const binaryString = window.atob(base64)
    const len = binaryString.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    return new Blob([bytes], { type: type })
  }
}
